import { useEffect, useState } from 'react';
import { Column } from '../pages/Components/Table/Types';
import { useForm } from './useForm';
import { ImportacaoXMLCadastrar } from '../routes/RoutesNames';
import { useNavigate } from 'react-router-dom';
import ImportacaoXMLController from '../controllers/ImportacaoXMLController';
import { ListaNotaFiscalEntrada } from '../shared/types/importacaoXML';
import { DatetimeBR } from '../shared/utils/helpers/date';
import { formatCurrency } from '../shared/utils/helpers/numbers';
import { toast } from 'react-toastify';
import * as React from 'react';
import { ButtonMenu } from '../shared/components/ButtonMenu';

interface Row {
  BtnExcluir?: JSX.Element;
  DataEmissao?: string;
  TipoArquivo?: string;
  Fornecedor?: string;
  Serie?: number;
  Id: number;
  ValorTotal?: string;
  BtnBaixar?: JSX.Element;
}

const useXmlImportPesquisar = () => {

  const navigate = useNavigate();
  const columns: Column[] = [
    { id: 'TipoArquivo', label: 'Arquivo', align: 'center', width: 50 },
    { id: 'DataEmissao', label: 'Data Emissao', minWidth: 0 },
    { id: 'Fornecedor', label: 'Fornecedor', minWidth: 0 },
    { id: 'Serie', label: 'Serie', minWidth: 0 },
    { id: 'Id', label: 'Numero', minWidth: 0 },
    { id: 'Status', label: 'Status', minWidth: 0 },
    { id: 'ValorTotal', label: 'Valor Total', minWidth: 0 },
    { id: 'BtnMenu', label: 'Ações', width: 60, minWidth: 0 },
  ];
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(false);
  const handleNavigation = () => {
    navigate(ImportacaoXMLCadastrar);
  };
  const [modalPreviewOpen, setModalPreviewOpen] = useState(false);
  const [nfPreView, setNfPreView] = useState<any>({});
  const [activeTab, setActiveTab] = useState('1');

  const onSubmit = async (data: any) => {
    await getList(data);
  };

  const form = useForm({
    onSubmit: onSubmit,
    initialValues: {},
  });

  const handleOpenModalView = async (nfId: number) => {
    setLoading(true);
    const result = await ImportacaoXMLController.consultarNfEntradaUnico(nfId);
    setLoading(false);
    console.log("RESULT AQUI -->", result)
    setNfPreView(result);
    setModalPreviewOpen(true);
  };

  const handleCloseModalView = () => {
    setModalPreviewOpen(false);
  }

  const getList = async (data?: ListaNotaFiscalEntrada) => {
    setLoading(true);
    const result = await ImportacaoXMLController.consultarNfEntrada({
      TipoArquivo: data?.TipoArquivo ?? '',
      CliNome: data?.CliNome ?? '',
      NfeSerie: data?.NfeSerie ?? 0,
      NfeStatus: data?.NfeStatus ?? '',
      NfeValorTotalNf: data?.NfeValorTotalNf ?? '',
      NfeDataEmissao: data?.NfeDataEmissao ?? '',
    });
    setRows(
      result.map((item: any) => {
        return {
          DataEmissao: DatetimeBR.getFullFriendlyDate(
            item.nfe_dataEmissao,
            false
          ),
          TipoArquivo: item.nfe_tipo_arquivo,
          Fornecedor: item.cli_nome,
          Serie: item.nfe_ser,
          Id: item.nfe_id,
          Status: item.nfe_status,
          ValorTotal: formatCurrency(item.nfe_valorTotalNf, 2, 2),
          BtnMenu: (
            <ButtonMenu
              items={[
                {
                  onClick: () => {handleOpenModalView(item.nfe_id)},
                  menu: 'Visualizar',
                },
                {
                  onClick: () => {console.log(item.prod_id)},
                  menu: 'Excluir', confirmar: `Excluir a importação de XML de ${item.cli_nome ?? ''}? Esta ação não pode ser desfeita.`,
                }
              ]}
            />
          )
        };
      })
    );
    setLoading(false);
  };

  const handleFinishNf = async () => {
    setLoading(true)
    const result = await ImportacaoXMLController.finalizarNfEntrada(nfPreView.nfe_id);
    setLoading(false);

    console.log('result', result);
    if (result) {
      setModalPreviewOpen(false);
      toast('Nota Fiscal finalizada com sucesso!', { type: 'success' });
    }
    if (!result) {
      toast('Houve um erro ao finalizar nota fiscal', { type: 'error' });
    }
  }

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    getList();
  }, []);

  return {
    ...form,
    loading,
    columns,
    rows,
    handleNavigation,
    modalPreviewOpen,
    handleCloseModalView,
    nfPreView,
    handleFinishNf,
    activeTab,
    handleTabChange,
  };
};

export default useXmlImportPesquisar;
